import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const isMobileOrTablet = () => {
  const touchFirst = window.matchMedia("(pointer: coarse)").matches || navigator.maxTouchPoints > 1;
  const compactScreen = window.matchMedia("(max-width: 1024px)").matches;
  const tabletScreen = window.matchMedia("(max-width: 1366px)").matches;
  return tabletScreen && (touchFirst || compactScreen);
};

const alreadyInstalled = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true || localStorage.getItem("flax-pwa-installed") === "true";

export default function PwaInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isMobileOrTablet() || alreadyInstalled()) return undefined;
    const handleBeforeInstall = (event) => { event.preventDefault(); setDeferredPrompt(event); setVisible(true); };
    const handleInstalled = () => { localStorage.setItem("flax-pwa-installed", "true"); setVisible(false); setDeferredPrompt(null); };
    window.addEventListener("beforeinstallprompt", handleBeforeInstall);
    window.addEventListener("appinstalled", handleInstalled);
    return () => { window.removeEventListener("beforeinstallprompt", handleBeforeInstall); window.removeEventListener("appinstalled", handleInstalled); };
  }, []);

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    if (choice.outcome === "accepted") localStorage.setItem("flax-pwa-installed", "true");
    setVisible(false);
    setDeferredPrompt(null);
  };

  if (!visible || alreadyInstalled()) return null;
  return <aside className="pwa-install-prompt" data-testid="pwa-install-prompt"><button className="pwa-dismiss" onClick={() => setVisible(false)} aria-label="Dismiss install prompt" data-testid="pwa-install-dismiss"><X /></button><div className="pwa-install-icon"><Download /></div><div><strong>Keep Flax Seed close</strong><p>Install the app for faster access on your phone or tablet.</p></div><button className="pwa-install-button" onClick={install} data-testid="pwa-install-button">Install</button></aside>;
}